import { Link, Outlet, useLocation } from 'react-router-dom';
import { Building2, LogOut } from 'lucide-react';
import { BarreraDeErrores } from '../barrera-de-errores';
import { useAuth, useCurrentUser } from '@/app/auth-provider';
import { Button } from '@/components/ui';

/**
 * El armazón del portal del cliente — tarea 8.3
 *
 * ── POR QUÉ NO REUTILIZA `AppLayout` ───────────────────────────────────────
 *
 * Porque el menú lateral es una lista de sitios a los que el cliente no puede
 * ir. Reutilizarlo y esconder entradas según el rol acabaría, tarde o
 * temprano, en un menú con «Proveedores» visible para un promotor: cada
 * sección nueva es una ocasión de olvidarse de la condición. Aquí no hay nada
 * que ocultar porque no hay nada que enseñar: dos enlaces y la sesión.
 *
 * Tampoco lleva buscador global ni campana. No es una versión recortada de la
 * aplicación: es otra cosa, para otra persona, que entra dos veces al mes a
 * ver por dónde va su obra y a bajarse un plano.
 */
export function PortalLayout() {
  const { pathname } = useLocation();
  const { logout } = useAuth();
  const user = useCurrentUser();

  return (
    <div className="flex h-full flex-col overflow-hidden bg-bg">
      <header className="flex shrink-0 items-center justify-between border-b border-border bg-surface px-4 py-3 sm:px-6">
        <Link to="/portal" className="flex items-center gap-2.5">
          <span className="grid size-8 place-items-center rounded-md bg-brand/10 text-brand">
            <Building2 className="size-4" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="text-sm font-semibold text-fg">{user.company.name}</span>
            <span className="text-xs text-fg-muted">Portal del cliente</span>
          </span>
        </Link>

        <div className="flex items-center gap-3">
          <span className="hidden text-sm text-fg-muted sm:inline">
            {user.firstName} {user.lastName}
          </span>
          <Button variant="ghost" size="sm" onClick={() => void logout()}>
            <LogOut className="size-4" />
            <span className="hidden sm:inline">Salir</span>
          </Button>
        </div>
      </header>

      <main className="min-w-0 flex-1 overflow-y-auto overflow-x-hidden">
        <BarreraDeErrores clave={pathname}>
          <Outlet />
        </BarreraDeErrores>
      </main>
    </div>
  );
}
